const FORM_ROUTES = [
  {
    path: '/forms/guest-feedback',
    name:'app-forms-guest-feedback',
    component: () => import('@/views/apps/forms/GuestFeedback.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Forms' },
        { title: 'Guest Feedback', active: true }
      ],
      pageTitle: 'Guest Feedback',
      rule: 'editor'
    }
  },

  {
    path: '/forms/pre-arrival-form',
    name:'app-forms-pre-arrival-form',
    component: () => import('@/views/apps/forms/PreArrivalConceirgeForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Forms' },
        { title: 'Pre-Arrival Form', active: true }
      ],
      pageTitle: 'Pre-Arrival Form',
      rule: 'editor'
    }
  },


  {
    path: '/forms/pre-arrival-checklist-form',
    name:'apps-forms-pre-arrival-checklist-form',
    component: () => import('@/views/apps/forms/PreArrivalChecklist.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Forms' },
        { title: 'Pre-Arrival Checklist Form', active: true }
      ],
      pageTitle: 'Pre-Arrival Checklist Form',
      rule: 'editor'
    }
  },

  {
    path: '/forms/lead-form',
    name:'apps-forms-lead-form',
    component: () => import('@/views/apps/forms/LeadForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Forms' },
        { title: 'Lead Form', active: true }
      ],
      pageTitle: 'Lead Form',
      rule: 'editor'
    }
  }
]
export default FORM_ROUTES
